import React, { useMemo } from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Image } from './';

const StyledGatsbyImage = styled(GatsbyImage)`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  max-width: ${({ maxwidth }) => maxwidth};
  max-height: ${({ maxheight }) => maxheight};
  border-radius: ${({ borderradius }) => borderradius};
  transition: all 0.5s;

  :hover {
    transform: ${({ hover }) => (hover ? 'scale(1.05)' : 'none')};
  }
`;

const GatsbyImageExtended = ({ src, alt, ...rest }) => {
  const { images } = useStaticQuery(graphql`
    query {
      images: allFile(
        filter: {
          internal: { mediaType: { regex: "/image/" } }
          extension: { ne: "svg" }
        }
      ) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP]
              width: 700
            )
          }
        }
      }
    }
  `);

  const match = useMemo(
    () => images.nodes.find((node) => src.includes(node.name)),
    [images, src]
  );
  const extension = src.split('.').pop();

  if (extension === 'svg') {
    return <Image src={src} alt={alt} loading="lazy" {...rest} />;
  }

  if (!match) return null;

  const { childImageSharp } = match || {};

  return (
    <StyledGatsbyImage
      image={childImageSharp.gatsbyImageData}
      alt={alt}
      {...rest}
    />
  );
};

export default GatsbyImageExtended;
